import { Link } from '@curology/ui-components-web/react/Link';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { centsToDollarsAndCents } from '../../utils/utils';

const Disclaimers = ({
  discountAmountInCents,
  setShowModal,
}: {
  discountAmountInCents: number | null;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <>
      <Typography className="cur-my-4" size="meta">
        {discountAmountInCents && (
          <>
            After your 30-day trial ends, your recurring subscription box will
            be {centsToDollarsAndCents(discountAmountInCents)}/mo more with Deep
            Cleanse<sup>Rx</sup>.{' '}
          </>
        )}
        <Link
          href=""
          onClick={(event) => {
            event.preventDefault();

            setShowModal(true);
          }}
        >
          See product ingredients & more
        </Link>
      </Typography>
      <Typography className="cur-mt-4" size="meta">
        Rx products are subject to consultation. If your dermatology provider
        cannot prescribe one due to any reason, it will be removed, and the cost
        of your subscription may be lower.
      </Typography>
    </>
  );
};

export default Disclaimers;
